import * as events from "events";

import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Domain as WebsideDomain } from "../../../lib/Domain/Webside";

@Injectable()
export class ProductService extends events.EventEmitter {

  // \lib\Server\Webside\route\api\userRoute.ts
  constructor(private http: Http) { super(); }
  public async Update(product: WebsideDomain.IProduct): Promise<WebsideDomain.IProduct> {
    const result = await this.http.post("/api/product/update", product)
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.IProduct;
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async Delete(product: WebsideDomain.IProduct): Promise<string> {
    const result = await this.http.post("/api/product/delete", product)
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data;
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async List(): Promise<WebsideDomain.IProduct[]> {
    const result = await this.http.get("/api/product/list")
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.IProduct[];
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async Register(deviceSerialNO: string, serialNO: string): Promise<WebsideDomain.IProduct> {
    const result = await this.http.post("/api/product/register", <WebsideDomain.IProductRegisterRequest>
      { deviceSerialNO, serialNO })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return result.data as WebsideDomain.IProduct;
    } else {
      throw new Error(`${result.message}`);
    }
  }
  public async Auth(serialNO: string, hash: string): Promise<void> {
    const result = await this.http.post("/api/product/auth", <WebsideDomain.IProductAuthRequest>
      { serialNO, hash })
      .toPromise()
      .then(response => response.json() as WebsideDomain.IResult)
      .catch();
    if (result && result.status === WebsideDomain.ResultCode.FTK_OK) {
      return;
    } else {
      throw new Error(`${result.message}`);
    }
  }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/product.service.ts